import React, { FC } from 'react'
import { Typography } from '../../Typography'

const Description: FC = ({ children }) =>
  <Typography as={'p'} color={'grey3'} variant={'label6'}>
    {children}
  </Typography>

export default Description
